import { render, staticRenderFns } from "./FileInputTrashButton.vue?vue&type=template&id=55855dda&scoped=true&"
import script from "./FileInputTrashButton.vue?vue&type=script&lang=js&"
export * from "./FileInputTrashButton.vue?vue&type=script&lang=js&"
import style0 from "./FileInputTrashButton.vue?vue&type=style&index=0&id=55855dda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55855dda",
  null
  
)

export default component.exports